var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgRteUnorderedList = function SvgRteUnorderedList(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M6.501 4.001h5.667m-5.667 4h5.667m-5.667 4h5.667m-7.833-8a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m0 4a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0m0 4a.333.333 0 1 1-.667 0 .333.333 0 0 1 .667 0"
  })));
};
export default SvgRteUnorderedList;